export const REQUEST_SHOW_STRINGS = {
  failedToLoadRequest: 'Failed to load request',
  retry: 'Retry',
  notFound: 'Request not found',
  backToRequests: 'Back to requests',
} as const
